import { Component, OnInit } from '@angular/core';
import  '../../assets/main.js';
declare var carousel: any;

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    carousel()
  }

}
